import React, { useState, useEffect } from 'react'
import { Grid, Typography, FormControl, FormControlLabel, Radio, RadioGroup } from '@material-ui/core'

function InDbsnpFilterModal({ value = null, onChange, onClose }) {
  // Convert value to string for radio buttons
  const convertToRadioValue = (val) => {
    if (val === true || val === 'true') return 'true'
    if (val === false || val === 'false') return 'false'
    return 'true' // default
  }

  const [localValue, setLocalValue] = useState(convertToRadioValue(value))

  // Update local state when prop changes
  useEffect(() => {
    setLocalValue(convertToRadioValue(value))
  }, [value])

  // Update parent state whenever localValue changes
  useEffect(() => {
    // Convert string to boolean for backend
    const booleanValue = localValue === 'true'
    console.log('InDbsnp filter value changed:', booleanValue)
    onChange(booleanValue)
  }, [localValue, onChange])

  console.log('InDbsnpFilterModal received value:', value, 'localValue:', localValue)

  const handleChange = (event) => {
    const newValue = event.target.value
    console.log('InDbsnp filter changed locally:', newValue)
    setLocalValue(newValue)
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          Select whether to include variants that are present in dbSNP database.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <FormControl component="fieldset">
          <RadioGroup
            value={localValue !== null && localValue !== undefined ? localValue : 'true'}
            onChange={handleChange}
          >
            <FormControlLabel value="true" control={<Radio />} label="True" />
            <FormControlLabel value="false" control={<Radio />} label="False" />
          </RadioGroup>
        </FormControl>
      </Grid>
    </Grid>
  )
}

export default InDbsnpFilterModal
